import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import { lineHeight, size } from "@clockwise/web-commons/src/styles/type.styles";

export const container: CSSProperties = {
  position: "relative",
  borderRadius: 8,
  background: greys.white,
  boxShadow: "rgba(0, 0, 0, 0.12) 0px 0px 2px 0px, rgba(0, 0, 0, 0.24) 0px 2px 2px 0px",
  overflow: "hidden",
  padding: "15px 11px",
  transition: "all .35s",
  WebkitFontSmoothing: "antialiased",
  transformOrigin: "center bottom",
  flexShrink: 0,
};

export const hidden: CSSProperties = {
  ...container,
  transform: "scaleY(0)",
};

export const icon = {
  htmlColor: greys.slate,
};

export const close: CSSProperties = {
  ...icon,
  position: "absolute",
  right: 3,
  top: 3,
};

export const header: CSSProperties = {
  marginTop: 20,
  marginBottom: 15,
  fontSize: size.md,
};

export const description: CSSProperties = {
  fontSize: size.md,
  color: greys.slate,
  lineHeight: lineHeight.std,
  marginBottom: 15,
};

export const listItem: CSSProperties = {
  ...description,
  display: "flex",
  marginBottom: 10,
};

export const bullet: CSSProperties = {
  fontSize: 18,
  color: colors.green.standard,
  marginRight: 10,
};

export const label: CSSProperties = {
  marginTop: 3,
};

export const learnMore: CSSProperties = {
  ...description,
  marginTop: 20,
  marginBottom: 0,
};

export const styles = {
  container,
  hidden,
  close,
  icon,
  header,
  description,
  listItem,
  bullet,
  label,
  learnMore,
};
